import { Histogram, LevelsOptions, NodeId } from 'web';
import { LevelsData } from '@/types/node';
import { HandleType } from '@/enums/handle-type.enum';
import { FlowGraph } from '../FlowGraph';

export class LevelsView {
  constructor(
    private graph: FlowGraph,
    private nodeId: NodeId,
  ) {}

  setLevelsOptions(options: Partial<LevelsOptions>, ongoing: boolean) {
    this.graph.wasmEdit((wasm) => {
      const prevOptions = this.graph.store.getNodeData<LevelsData>(this.nodeId).options;
      return wasm.setLevelsOptions(this.nodeId, { ...prevOptions, ...options });
    }, ongoing);
    this.graph.updateNodeOutputs(this.nodeId, ongoing);
  }

  /// Returns a histogram for the image as input to this node.
  /// The values in the arrays are the number of pixels that have the corresponding value, where the value is in the range 0..255.
  computeInputHistogram(): Histogram | undefined {
    return this.graph.wasm.call((wasm) => wasm.computeInputHistogram(this.nodeId, 'file'));
  }

  hasValidInput(): boolean {
    const input = this.graph.store.getNodeDataNullable<LevelsData>(this.nodeId)?.inputNode;
    const inputType = input ? this.graph.nodeOutputType(input.nodeId, input.outputId) : undefined;
    return inputType === HandleType.Image || inputType === HandleType.Video;
  }
}
